import { Component, OnInit } from '@angular/core';
import { LimitsService } from '../../../../resources/limits/limits.service';
import { MzToastService } from 'ng2-materialize';
import { PromptService } from '../../../../services/prompt/prompt.service';
import { Limit } from '../../../../model/limit';
import { Observable } from 'rxjs/Observable';
import { SpinnerService } from '../../../../services/spinner/spinner.service';

@Component({
  selector:    'app-limits-summary',
  templateUrl: './limits-summary.component.html',
  styleUrls:   [ './limits-summary.component.scss' ]
})
export class LimitsSummaryComponent implements OnInit {

  limits: Limit[];

  loading = true;

  p = 1;

  constructor(private limitsService: LimitsService,
              private toast: MzToastService,
              private spinner: SpinnerService,
              private prompt: PromptService) {
  }

  ngOnInit() {
    this.limitsService.query().subscribe((res) => {
      this.loading = false;
      this.limits = res;
    });
  }

  removeLimit(limit: Limit): void {
    let spinner;
    this.prompt.confirm(`Usunąć limit ${limit.name}?`)
      .switchMap((v) => {
        if (v) {
          spinner = this.spinner.show('Usuwam...');
          return this.limitsService.destroy(limit);
        } else {
          return Observable.empty();
        }
      })
      .subscribe(() => {
        this.toast.show('Usunięto limit', 2000, 'success');
        spinner.close();
        this.ngOnInit();
      }, () => {
        spinner.close();
        this.toast.show('Nie można usunąć limitu', 2000, 'error');
      } );

  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/cards/limits-summary/limits-summary.component.ts